// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1QcjZ","errorLogs":"styles_errorLogs__2vfaV"};